import { AddressLocalized, PPNDealer } from "./dealer-response";

export function getAddressInformation(
  dealer: PPNDealer,
  language: string,
): AddressLocalized {
  if (language === "en") return dealer.address;
  return {
    street: dealer.addressLocalized.street
      ? dealer.addressLocalized.street
      : dealer.address.street,
    state: dealer.addressLocalized.state
      ? dealer.addressLocalized.state
      : dealer.address.state,
    city: dealer.addressLocalized.city
      ? dealer.addressLocalized.city
      : dealer.address.city,
  };
}

export function getDealerName(dealer: PPNDealer, language: string): string {
  if (language === "en") return dealer.name;
  return dealer.nameLocalized ? dealer.nameLocalized : dealer.name;
}
